import React from 'react';
import { Stack, AvatarGroup, Avatar, Tooltip, Typography } from '@mui/material';

// Generate a deterministic color from email string
function stringToColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += (`00${value.toString(16)}`).slice(-2);
  }
  return color;
}

function stringAvatar(email: string) {
  const initials = email
    .split('@')[0]
    .split(/[._]/)
    .map((p) => p[0]?.toUpperCase() + p[1]?.toUpperCase() || '')
    .join('')
    .slice(0, 2);

  return {
    sx: {
      bgcolor: `${stringToColor(email)} !important`,
      color: 'white',
      fontWeight: 'bold',
      fontSize: 13,
      width: 32,
      height: 32,
    },
    children: initials,
  };
}

interface TeamAvatarsProps {
  teams: string[];
}

export default function TeamAvatars({ teams }: TeamAvatarsProps) {
  return (
    <Typography component="div" variant="body1">
      <Stack direction="row" flexWrap="wrap">
        <AvatarGroup
          max={4}
          sx={{
           
            ".MuiAvatar-root": {
              height: 32,
              width: 32,
              fontSize: 13,
            },
          }}
        >
          {teams.map((email) => (
            <Tooltip key={email} title={email}>
              <Avatar {...stringAvatar(email)} />
            </Tooltip>
          ))}
        </AvatarGroup>
      </Stack>
    </Typography>
  );
}